import {
  Component,
  OnInit,
  HostListener,
  ElementRef,
  ViewChild,
} from '@angular/core';
import { Consultant } from '../../models/Consultant.model';
import { ConsultantService } from '../../services/consultant.service';
import { CommonHelper } from '../../shared/helpers/CommonHelper';
import { ConsultantSearch } from '../../models/ConsultantSearch.model';
import { DropDownList } from '../../models/DropDownList.model';
import { Responsible } from '../../models/Responsible.model';
import { ExcellenceCenter } from '../../models/ExcellenceCenter.model';
import { UserService } from '../../services/user.service';
import { LocalStorage } from '../../shared/wrappers/LocalStorage';
import { GUARDS } from '../../shared/auth/Roles';
import { ToastsManager } from 'ng2-toastr';
import { ErrorHandlerProvider } from '../../shared/providers/errorHandler.provider';
import { ExcellenceCentersService } from '../../services/excellenceCenters.service';
import * as _ from 'lodash';
import { ContractType } from '../../shared/enums/ContractType';


@Component({
  selector: 'app-consultants',
  templateUrl: './consultants.component.html',
  styleUrls: ['./consultants.component.scss'],
})
export class ConsultantsComponent implements OnInit {
  @ViewChild('buttonModalContractStatus') buttonModalContractStatus: ElementRef;

  dropDownListContract: DropDownList[] = new Array<DropDownList>();
  selectedContractItems: DropDownList[] = new Array<DropDownList>();
  dropDownContractSettings = {};

  dropDownListResponsible: DropDownList[] = new Array<DropDownList>();
  selectedResponsibleItems: DropDownList[] = new Array<DropDownList>();
  dropDownResponsibleSettings = {};

  dropDownListExcellenceCenters: DropDownList[] = new Array<DropDownList>();
  selectedExcellenceCentersItems: DropDownList[] = new Array<DropDownList>();
  dropDownExcellenceCentersSettings = {};

  dropDownListSupportCenters: DropDownList[] = new Array<DropDownList>();
  selectedSupportCenterItems: DropDownList[] = new Array<DropDownList>();
  dropDownSupportCentersSettings = {};

  excellenceCenters: Array<ExcellenceCenter> = [];
  allCenters: Array<ExcellenceCenter> = [];
  supportCenters: Array<ExcellenceCenter> = [];
  responsibles: Responsible[] = new Array<Responsible>();

  itemsPerPage: number[] = [10, 50, 100];
  totalItems: number = 0;
  currentPage: number = 1;
  consultants: Consultant[] = null;
  commonHelper: CommonHelper = new CommonHelper();
  consultantSearchModel: ConsultantSearch = new ConsultantSearch();

  consultantAux: Consultant = new Consultant();
  user;
  loading: boolean;
  typeContractAux: string = '';
  GUARDS = GUARDS;
  isBusinessPartner: boolean = false;
  isDP: boolean = false;
  isUserPeople: boolean = false;
  notAllowedToCreateConsultants: boolean = false;
  governanceDivisions: Array<number> = [];

  constructor(
    private consultantService: ConsultantService,
    private userService: UserService,
    private localStorage: LocalStorage,
    private toastr: ToastsManager,
    private errorHandler: ErrorHandlerProvider,
    private excellenceCentersService: ExcellenceCentersService,
  ) {}

  async ngOnInit() {
    this.loading = true;
    this.consultantSearchModel = new ConsultantSearch();
    this.responsibles = await this.userService.getAllUsersAsResponsibles();
    this.allCenters = await this.excellenceCentersService.getAll();

    this.excellenceCenters = this.allCenters.filter(center => center.type == 1 );
    this.excellenceCenters = _.orderBy(this.excellenceCenters, [sup => sup.name.toUpperCase()]);

    this.supportCenters = this.allCenters.filter(center => center.type == 2 );
    this.supportCenters = _.orderBy(this.supportCenters, [sup => sup.name.toUpperCase()]);


    this.user = this.localStorage.retrieve('user');
    this.checkPermission();
    this.dropDownListContract = this.commonHelper.getDropDownListItemsEnum(
      this.commonHelper.getAllContractType(),
      'Contract'
    );

    this.dropDownContractSettings = this.commonHelper.getDropDownSettings(
      true,
      'Modelos',
      false,
      'Marcar todas os contratos',
      'Desmarcar todas os contratos',
      false,
      null,
      ''
    );
    this.dropDownListResponsible = this.commonHelper.getDropDownListItems(
      this.responsibles,
      '_id',
      'name'
    );
    this.dropDownResponsibleSettings = this.commonHelper.getDropDownSettings(
      true,
      'Gestores',
      false,
      'Marcar todas os gestores',
      'Desmarcar todas os gestores',
      true,
      null,
      ''
    );

    this.dropDownListExcellenceCenters = this.commonHelper.getDropDownListItems(
      this.excellenceCenters,
      '_id',
      'name'
    );
    this.dropDownListSupportCenters = this.commonHelper.getDropDownListItems(
      this.supportCenters,
      '_id',
      'name'
    );
    this.dropDownExcellenceCentersSettings =
      this.commonHelper.getDropDownSettings(
        false,
        'Centro de Excelência',
        false,
        'Marcar todas os centro de excelência',
        'Desmarcar todas os centro de excelência',
        true,
        null,
        ''
      );
    this.dropDownSupportCentersSettings = this.commonHelper.getDropDownSettings(
      false,
      'Área de suporte',
      false,
      'Marcar todas as áreas de suporte',
      'Desmarcar todas as áreas de suporte',
      true,
      null,
      ''
    );
    this.checkIfCanCreateConsultants();
    await this.searchConsultants(1);
    this.loading = false;
  }

  @HostListener('window:keyup', ['$event'])
  keyEvent(event: KeyboardEvent) {
    if (event.keyCode === 13) {
      this.searchConsultants(1);
    }
  }

  async searchConsultants(page, toexport?) {
    try {
      this.loading = true;
      this.consultantSearchModel.kind = '';
      this.consultantSearchModel.excellenceCenter = [];
      for (let contract of this.selectedContractItems)
        this.consultantSearchModel.kind = contract.id;
      for (let responsible of this.selectedResponsibleItems)
        this.consultantSearchModel.responsible = responsible.id;
      for (let ec of this.selectedExcellenceCentersItems)
        this.consultantSearchModel.excellenceCenter.push(ec.id);
      for (let cs of this.selectedSupportCenterItems)
        this.consultantSearchModel.supportCenter.push(cs.id);

      this.currentPage = page ? page : 1;
      this.consultantSearchModel.skip =
        (page - 1) * this.consultantSearchModel.limit;

      if (toexport) {
        delete this.consultantSearchModel.skip;
        this.consultants = await this.consultantService.searchConsultants(
          this.consultantSearchModel
        );
      } else {
        this.consultants = await this.consultantService.searchConsultants(
          this.consultantSearchModel
        );
        this.consultants.forEach(consultant => {
            this.checkConsultantSupportCenter(consultant);
        })
      }

      this.totalItems = this.consultantSearchModel.totalItems;
      this.loading = false;
    } catch (error) {
      this.loading = false;
      this.errorHandler.interceptError(error, 'Consultor');
    }
  }

  isActive(active: boolean) {
    return active ? 'badge-success' : 'badge-danger';
  }

  isActiveText(active: boolean) {
    return active ? 'Ativo' : 'Inativo';
  }

  openModalContractStatus(c: any, type: string) {
    this.typeContractAux = type;
    this.consultantAux = { ...c };
    this.buttonModalContractStatus.nativeElement.click();
  }

  async close() {
    this.consultantAux = new Consultant();
    this.typeContractAux = '';
    await this.searchConsultants(1);
  }

  async changeContractStatus() {
    try {
      let response = await this.consultantService.changeContract(
        this.consultantAux._id,
        {
          type: this.typeContractAux,
          generated:
            this.typeContractAux === 'confidentiality'
              ? this.consultantAux.generatedConfidentiality
              : this.typeContractAux === 'individualAgreementHoliday'
              ? this.consultantAux.generatedIndividualAgreementHoliday
              : this.consultantAux.contract.generated,
        }
      );
      if (response._id)
        this.toastr.success(
          `Status do ${
            this.typeContractAux === 'confidentiality'
              ? 'termo de confidencialidade'
              : this.typeContractAux === 'individualAgreementHoliday'
              ? 'acordo individual'
              : 'contrato'
          } atualizado com sucesso.`
        );
      else this.errorHandler.interceptError(response, 'Consultor');
      await this.close();
    } catch (err) {
      this.errorHandler.interceptError(err, 'Consultor');
      await this.close();
    }
  }

  checkPermission() {
    let permission = this.user.permission;
    if (permission === GUARDS.BUSINESSPARTNER) {
      this.isBusinessPartner = true;
    } else if (permission == GUARDS.DP) {
      this.isDP = true;
    } else if (permission == GUARDS.PEOPLE){
        this.isUserPeople = true;
    }
  }

  checkConsultantSupportCenter(consultant: Consultant) {
    if (this.user.permission == GUARDS.RS) {
        const centersIds = this.commonHelper.excellenceCenterIds();
        if (consultant.supportCenter && consultant.supportCenter._id == centersIds.SGA) {
            Object.assign(consultant, {isBlockedForRs: true});
        }
    }
  }

  checkIfCanCreateConsultants() {
    const notAllowed = [GUARDS.PEOPLE, GUARDS.BUSINESSPARTNER];
    this.notAllowedToCreateConsultants = notAllowed.includes(this.user.permission);
  }
}



// WEBPACK FOOTER //
// ./src/app/views/consultants/consultants.component.ts